import React, { useEffect } from "react";
import { TableHeaderColumn, BootstrapTable } from "/src/component/table/BootstrapTable";

import Loading from "../../../component/Loading";
import { dataTableConfig } from "../../../config/config";
import { VISIT_PAGE, TRANSLATION_DOWNLOADER } from "../../../config/lang";

import { call } from "../../../util/action";
import CreateMsgPopup from "../../../util/CreateMsgPopup";
import { visitItemMonitoringAction, dateFormat } from "../../../util/formatter";
import { getStore } from "../../../util/redux/store";
import { translate } from "../../../util/util";

const me = getStore().getState().me;
function Monitoring({ data }) {
  const [state, setState] = React.useState({ monitoring: "", loading: false });
  const [checkedRows, setCheckedRows] = React.useState([]);
  const [isMsgStatus, setIsMsgStatus] = React.useState({ status: false, type: "error", message: "" });
  const [updatedData, getUpdatedData] = React.useState(false);
  //default object for approve or reject the task
  const approveRejectObject = {
    object_type: "pricemonitoringreport", //('report', “pricemonitoringreport”, “answer”)
    is_approved: null,
    comment: "",
  };

  useEffect(() => {
    setState({ loading: true });

    let url = `visits/${data.id}/price_monitoring_in_visit/`;

    call({ method: "GET", url }, response => {
      setState({ monitoring: response.results, loading: false });
    });
  }, [data, updatedData]);

  const getImgObj = src => {
    if (!src) {
      return <p className="monitoring-product-empty-img">No photo</p>;
    }
    return (
      <a href={src} target="_blank" rel="noopener noreferrer">
        <img src={src} className="monitoring-product-img" alt="Click to open in new window" />
      </a>
    );
  };

  const handleCheckboxChange = (e, row) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      setCheckedRows(prev => [...prev, row.id]);
    } else {
      setCheckedRows(prev => prev.filter(id => id !== row.id));
    }
  };

  const prepareData = data => {
    return checkedRows.length === 1 ? data[0] : checkedRows.length > 1 ? data : null;
  };

  const sentAnswer = (type, body, isArray) => {
    const approveRejectStatus = type === "ACCEPT" ? true : false;
    const isInValid = isArray ? body.object_ids?.length < 1 : !body.object_id;

    if (isInValid) {
      setIsMsgStatus({ status: true, type: "error", message: translate(VISIT_PAGE, "task_has_empty_error", me.language) });
      return;
    }

    const url = isArray ? "approvals/bulk_approval/" : "approvals/";
    call({ method: "POST", url, post: body }, response => {
      if (response) {
        const msg = approveRejectStatus
          ? translate(TRANSLATION_DOWNLOADER, "task_accept_msg", me.language)
          : translate(TRANSLATION_DOWNLOADER, "task_reject_msg", me.language);

        setIsMsgStatus({ status: true, type: "success", message: msg });
        setCheckedRows([]);
        getUpdatedData(!updatedData);
      } else {
        setIsMsgStatus({ status: true, type: "warning", message: JSON.stringify(response) });
        console.log(response);
      }
    });
  };

  const approveRejectTaskHandler = type => {
    const data = prepareData(checkedRows);
    const objSize = Array.isArray(data) ? "object_ids" : "object_id";
    approveRejectObject[objSize] = data;
    approveRejectObject.is_approved = type === "REJECT" ? false : type === "ACCEPT" ? true : null;
    sentAnswer(type, approveRejectObject, Array.isArray(data));
  };

  const approveRejectTaskQuickHandler = (item, type) => {
    const data = item.id;
    approveRejectObject.object_id = data;
    approveRejectObject.is_approved = type === "REJECT" ? false : type === "ACCEPT" ? true : null;

    sentAnswer(type, approveRejectObject, Array.isArray(data));
  };

  const getApprovalInfo = item => {
    if (!item?.approved_by) return;
    return (
      <div>
        <p>
          {item.approved_by.first_name} {item.approved_by.last_name}
        </p>
        <span>{dateFormat(item.approved_at)}</span>
      </div>
    );
  };
  const getApprovalStatus = item => {
    if (!item) return;
    const statusClass =
      item.is_approved ? "task-status-approved" : item.is_approved === false ? "task-status-rejected" : item.is_approved === null ? "pending" : "";
    const label = item.is_approved ? "Approved" : item.is_approved === false ? "Rejected" : item.is_approved === null ? "Pending" : "";
    return <span className={`visit-task-status ${statusClass}`}>{label}</span>;
  };

  const handleSelectAll = () => {
    if (checkedRows.length > 0) {
      setCheckedRows([]);
      return;
    }

    const validRowIds = state.monitoring.filter(row => row.id).map(row => row.id);
    if (validRowIds.length === 0) setIsMsgStatus({ status: true, type: "error", message: translate(VISIT_PAGE, "task_has_answer_error", me.language) });
    setCheckedRows(validRowIds);
  };

  return (
    <>
      <div className="visit-monitoring-tab-wrapper">
        {isMsgStatus.status && <CreateMsgPopup setIsMsg={setIsMsgStatus} isMsg={isMsgStatus} />}
        {state.monitoring ? (
          <>
            <div className={`visit-single-btn-wrapper mb-4 ${checkedRows.length > 0 ? "visible" : "hidden"}`}>
              <span>
                {translate(VISIT_PAGE, "monitoring_tab_selected_label", me.language)}: {checkedRows.length}
              </span>
              <button type="button" className="btn btn-default approve-visit" onClick={() => approveRejectTaskHandler("ACCEPT")}>
                <span></span>
              </button>
              <button type="button" className="btn btn-default reject-visit" onClick={() => approveRejectTaskHandler("REJECT")}>
                <span>&times;</span>
              </button>
            </div>
            <BootstrapTable
              data={state.monitoring}
              version="4"
              striped
              hover
              bordered={false}
              pagination={false}
              search={false}
              multiColumnSearch={true}
              columnFilter={false}
              options={{ ...dataTableConfig }}
              className="themed-main-table-container"
              trClassName="visit-monitoring-tab-item"
              tableHeaderClass="primary">
              <TableHeaderColumn
                dataField="checkbox"
                dataFormat={(cell, row) => <input type="checkbox" checked={checkedRows.includes(row.id)} onChange={e => handleCheckboxChange(e, row)} />}
                width="50px">
                <input type="checkbox" checked={checkedRows.length > 0} onChange={handleSelectAll} />
              </TableHeaderColumn>
              <TableHeaderColumn dataField="product_name" isKey={true} width="80px">
                {translate(VISIT_PAGE, "monitoring_tab_pname_label", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataField="product_code" width="120px">
                {translate(VISIT_PAGE, "monitoring_tab_pcode_label", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataField="price" width="100px" dataAlign="center">
                {translate(VISIT_PAGE, "monitoring_tab_price_label", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataField="sale_price" width="100px" dataAlign="center">
                {translate(VISIT_PAGE, "monitoring_tab_sale_price_label", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataFormat={getImgObj} dataField="photo_url" columnClassName={"monitoring-product-img-col"} width="240px">
                {translate(VISIT_PAGE, "monitoring_tab_photo_label", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataField="comment" width="180px">
                {translate(VISIT_PAGE, "monitoring_tab_comment_label", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataField="approval" dataFormat={getApprovalInfo} width="120px">
                {translate(VISIT_PAGE, "approved_by", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataField="approval" dataFormat={getApprovalStatus} width="120px">
                {translate(VISIT_PAGE, "task_tab_status_label", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataFormat={(i, item) => {
                  return visitItemMonitoringAction(i, item, approveRejectTaskQuickHandler);
                }}
                width="80px"></TableHeaderColumn>
            </BootstrapTable>
          </>
        ) : (
          <Loading loading={state.loading} />
        )}
      </div>
    </>
  );
}

export default Monitoring;